export interface IPropertyOwnerVesting {
    vestingOwner: string;
    vestingOwnershipRight: string;
    vestingEtAl: string;
}

export class PropertyOwnerVesting implements IPropertyOwnerVesting {
    public vestingOwner: string;
    public vestingOwnershipRight: string;
    public vestingEtAl: string;
}